// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.request-card {
  margin: 10px;
}

.empty-icon-container {
  margin: 1em auto;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-family: "Dosis", sans-serif;
}

.mat-mdc-tab {
  padding-bottom: 100px;
}

.tab-title {
  padding-right: 20px;
  padding-left: 20px;
  letter-spacing: normal !important;
}

.createdRequest-status {
  margin-top: -1px !important;
}

.actions {
  margin-top: -5px !important;
}

.highlightedTitle {
  background: #104a64;
  width: 100%;
  margin-top: 25px;
  margin-bottom: 25px;
  position: relative;
}
.highlightedTitle .page-title {
  color: white;
  text-align: center;
  padding: 10px 0;
  border-radius: 5px;
  font-size: 1.8rem;
  margin-top: 0;
  margin-bottom: 0;
}
.highlightedTitle .button-action {
  color: white;
  position: absolute;
  right: 0;
}

:host ::ng-deep .my-mat-tab .mat-mdc-tab-list {
  border-bottom: solid 1px #e0e0e0;
}

:host ::ng-deep .my-mat-tab .mdc-tab.mat-mdc-tab.mdc-tab--active {
  border: solid 1px #e0e0e0 !important;
  border-radius: 10px !important;
  box-shadow: none !important;
  width: 200px !important;
  font-weight: bold !important;
  padding-left: 20px !important;
  color: #673ab7;
}
:host ::ng-deep .my-mat-tab .mdc-tab.mat-mdc-tab.mdc-tab--active .mdc-tab__text-label {
  letter-spacing: normal !important;
}

::ng-deep .cdk-overlay-pane {
  width: auto;
}

::ng-deep .mat-mdc-text-field-wrapper {
  background-color: white !important;
}`, "",{"version":3,"sources":["webpack://./src/app/+home/+document-request/see-requests/see-requests.component.scss"],"names":[],"mappings":"AAEA;EACE,YAAA;AADF;;AAIA;EACE,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,gCAAA;AADF;;AAKA;EACE,qBAAA;AAFF;;AAKA;EACE,mBAAA;EACA,kBAAA;EACA,iCAAA;AAFF;;AAKA;EACE,2BAAA;AAFF;;AAKA;EACE,2BAAA;AAFF;;AAKA;EACE,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;AAFF;AAGE;EACE,YAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,aAAA;EACA,gBAAA;AADJ;AAIE;EACE,YAAA;EACA,kBAAA;EACA,QAAA;AAFJ;;AAKA;EACE,gCAAA;AAFF;;AAIA;EACE,oCAAA;EACA,8BAAA;EACA,2BAAA;EACA,uBAAA;EACA,4BAAA;EACA,6BAAA;EACA,cAAA;AADF;AAEE;EACE,iCAAA;AAAJ;;AAGA;EACE,WAAA;AAAF;;AAKA;EACE,kCAAA;AAFF","sourcesContent":["@import \"/src/styles/_variables.scss\";\r\n\r\n.request-card {\r\n  margin: 10px;\r\n}\r\n\r\n.empty-icon-container {\r\n  margin: 1em auto;\r\n  text-align: center;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  font-family: \"Dosis\", sans-serif;\r\n\r\n}\r\n\r\n.mat-mdc-tab {\r\n  padding-bottom: 100px;\r\n}\r\n\r\n.tab-title {\r\n  padding-right: 20px;\r\n  padding-left: 20px;\r\n  letter-spacing: normal !important;\r\n}\r\n\r\n.createdRequest-status {\r\n  margin-top: -1px !important;\r\n}\r\n\r\n.actions {\r\n  margin-top: -5px !important;\r\n}\r\n\r\n.highlightedTitle {\r\n  background: #104a64;\r\n  width: 100%;\r\n  margin-top: 25px;\r\n  margin-bottom: 25px;\r\n  position: relative;\r\n  .page-title {\r\n    color: white;\r\n    text-align: center;\r\n    padding: 10px 0;\r\n    border-radius: 5px;\r\n    font-size: 1.8rem;\r\n    margin-top: 0;\r\n    margin-bottom: 0;\r\n  }\r\n\r\n  .button-action {\r\n    color: white;\r\n    position: absolute;\r\n    right: 0;\r\n  }\r\n}\r\n:host ::ng-deep .my-mat-tab .mat-mdc-tab-list {\r\n  border-bottom: solid 1px #e0e0e0;\r\n}\r\n:host ::ng-deep .my-mat-tab .mdc-tab.mat-mdc-tab.mdc-tab--active {\r\n  border: solid 1px #e0e0e0 !important;\r\n  border-radius: 10px !important;\r\n  box-shadow: none !important;\r\n  width: 200px !important;\r\n  font-weight: bold !important;\r\n  padding-left: 20px !important;\r\n  color: #673ab7;\r\n  .mdc-tab__text-label {\r\n    letter-spacing: normal !important;\r\n  }\r\n}\r\n::ng-deep .cdk-overlay-pane {\r\n  width: auto;\r\n  //top: 283.016px;\r\n  //left: 1070px;\r\n  //right: 0px;\r\n}\r\n::ng-deep .mat-mdc-text-field-wrapper {\r\n  background-color: white !important;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
